import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EmailBoxComponent } from './email-box.component';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { EmailViewerModule } from 'shared/components/email-viewer/email-viewer.module';
import { AlertBoxModule } from 'shared/components/alert-box/alert-box.module';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { WrapUpPanelModule } from '../../shared/components/wrapup-panel/wrap-up-panel.module';
import { TinyMCEEditorModule } from 'shared/components/editor/editor.module';
import { EmailOutgoingHeaderModule } from 'shared/components/email-outgoing-header/email-outgoing-header.module';
import { WorkWidgetControlPanelModule } from 'shared/components/work-widget-control-panel/work-widget-control-panel.module';
import { EmailAttachmentsModule } from 'shared/components/email-attachments/email-attachments.module';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';
import { TransferPanelModule } from 'shared/components/transfer-panel/transfer-panel.module';
import { ngfModule } from 'angular-file';
import { FileUploadService } from 'common/api/file-upload-service';
import { WorkItemWidgetSharedModule } from '../../shared/work-item-widget-shared.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    ngfModule,
    AlertBoxModule,
    AutoSaveModule,
    EmailAttachmentsModule,
    EmailOutgoingHeaderModule,
    EmailViewerModule,
    WorkItemWidgetSharedModule,
    LoadingModule,
    SvgIconModule,
    TinyMCEEditorModule,
    TransferPanelModule,
    VisitorHistoryModule,
    WorkWidgetControlPanelModule,
    WrapUpPanelModule
  ],
  declarations: [
    EmailBoxComponent
  ],
  providers: [
    FileUploadService
  ],
  exports: [
    EmailBoxComponent
  ]
})
export class EmailBoxModule {}
